import { AdminPopupService } from "../../services/admin-popup.service.js";
import { ModalManager } from "../../utils/ModalManager.js";
import { AlertModal } from "../../components/modals/AlertModal.js";
import { ConfirmModal } from "../../components/common/ConfirmModal.js";
import { SeriesPickerModal } from "../../components/common/SeriesPickerModal.js";
import { templateTranslationService } from "../../services/TranslationService.js";

export const AdminPopupsPage = () => {
    const container = document.createElement('div');
    container.className = "max-w-4xl mx-auto px-4 py-8 pb-32";

    container.innerHTML = `
        <div class="mb-8 flex items-center justify-between">
            <h1 class="text-2xl font-bold text-gray-900 flex items-center gap-2">
                <span class="material-symbols-outlined text-blue-600">factory</span>
                팝업 팩토리 & 공지 통합
            </h1>
            <div class="text-sm text-gray-500">
                팝업생성 = 공장가동 🏭
            </div>
        </div>

        <!-- Factory Form -->
        <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
            <h2 class="text-lg font-bold mb-4 border-b pb-2">새 팝업 생산</h2>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <!-- Image Preview Area -->
                <div class="space-y-2">
                    <label class="block text-sm font-medium text-gray-700">이미지 첨부 (필수)</label>
                    <div id="image-drop-zone" class="border-2 border-dashed border-gray-300 rounded-lg h-48 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-50 transition-colors relative overflow-hidden group">
                        <span class="material-symbols-outlined text-gray-400 text-4xl group-hover:text-blue-500">cloud_upload</span>
                        <span class="text-xs text-gray-400 mt-2">클릭 또는 드래그하여 업로드</span>
                        <input type="file" id="popup-file-input" accept="image/*" class="absolute inset-0 opacity-0 cursor-pointer">
                        <img id="preview-img" class="absolute inset-0 w-full h-full object-contain bg-white hidden">
                    </div>
                </div>

                <!-- Input Fields -->
                <div class="space-y-4">
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-1">제목 (관리용)</label>
                        <input type="text" id="popup-title" class="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm" placeholder="예: 여름방학 이벤트">
                    </div>
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-1">링크 URL (선택)</label>
                        <div class="flex gap-2">
                             <input type="text" id="popup-link" class="flex-grow px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm" placeholder="작품을 연결하거나 URL 직접 입력">
                             <button id="btn-select-series" class="px-3 py-2 bg-gray-100 hover:bg-gray-200 text-gray-600 rounded-lg text-sm font-bold whitespace-nowrap border border-gray-300">
                                 작품 찾기
                             </button>
                        </div>
                    </div>
                     <div class="grid grid-cols-2 gap-2">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">시작일</label>
                            <input type="date" id="popup-start-date" class="w-full px-3 py-2 border rounded-lg text-sm">
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">종료일</label>
                            <input type="date" id="popup-end-date" class="w-full px-3 py-2 border rounded-lg text-sm">
                        </div>
                    </div>
                    
                    <!-- Integration Checkbox -->
                    <div class="flex items-center gap-2 pt-2">
                        <input type="checkbox" id="chk-add-notice" class="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500">
                        <label for="chk-add-notice" class="text-sm font-bold text-gray-800 select-none cursor-pointer">
                            [What's New] 공지사항에도 자동 등록
                        </label>
                        <select id="notice-tag-selector" class="ml-auto text-xs px-2 py-1 border rounded bg-gray-50 text-gray-700 outline-none focus:ring-1 focus:ring-blue-500">
                            <option value="Event" selected>EVENT</option>
                            <option value="Notice">NOTICE</option>
                            <option value="New">NEW</option>
                            <option value="Update">UPDATE</option>
                            <option value="Custom">직접 입력</option>
                        </select>
                        <input type="text" id="custom-tag-input" class="hidden ml-2 w-24 text-xs px-2 py-1 border rounded bg-white text-gray-700 outline-none focus:ring-1 focus:ring-blue-500" placeholder="태그 입력">
                    </div>
                     <!-- Notice Content (Hidden by default) -->
    <!-- Notice Content (Hidden by default) -->
                    <div id="notice-content-area" class="hidden mt-2">
                        <label class="block text-sm font-medium text-gray-700 mb-1">공지 내용 (직접 작성)</label>
                        <textarea id="notice-content-input" class="w-full px-3 py-2 border rounded-lg text-sm h-24 resize-none focus:ring-2 focus:ring-blue-500 outline-none" placeholder="공지사항 내용을 입력하세요..."></textarea>
                    </div>

                    <!-- Auto Translation Option -->
                    <div class="flex items-center gap-2 py-2 border-t border-dashed border-gray-200 mt-2">
                         <input type="checkbox" id="chk-auto-translate" class="w-4 h-4 text-purple-600 rounded border-gray-300 focus:ring-purple-500" checked>
                         <label for="chk-auto-translate" class="text-xs font-bold text-purple-700 select-none cursor-pointer flex items-center gap-1">
                             <span class="material-symbols-outlined text-sm">translate</span>
                             Auto-Translate (Convert to 9 Languages automatically)
                         </label>
                    </div>

                    <button id="btn-produce" class="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 rounded-xl transition-all shadow-md active:scale-95 flex items-center justify-center gap-2">
                         <span class="material-symbols-outlined">precision_manufacturing</span>
                         생산 시작 (저장)
                    </button>
                </div>
            </div>
        </div>

        <!-- Existing Popups List -->
        <h2 class="text-lg font-bold mb-4">가동 중인 팝업</h2>
        <div id="popup-list" class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="flex justify-center py-10 w-full col-span-2">
                <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            </div>
        </div>

        <!-- Notices Management Section -->
        <div class="flex items-center justify-between mt-12 border-t pt-8 mb-4">
            <h2 class="text-lg font-bold flex items-center gap-2">
                <span class="material-symbols-outlined text-yellow-500">campaign</span>
                What's New (공지사항) 관리
            </h2>
            <button id="btn-sync-all-notices" class="px-3 py-1.5 bg-indigo-100 hover:bg-indigo-200 text-indigo-700 rounded-lg text-xs font-bold flex items-center gap-1 transition-colors">
                 <span class="material-symbols-outlined text-sm">sync_alt</span>
                 Legacy Data Sync (비용 0원)
            </button>
        </div>
        <div id="notice-list" class="space-y-4 mb-12">
            <div class="text-center py-10 text-gray-400">공지 로딩 중...</div>
        </div>
    `;

    // Logic Elements
    const fileInput = container.querySelector('#popup-file-input');
    const previewImg = container.querySelector('#preview-img');
    const btnProduce = container.querySelector('#btn-produce');
    const popupList = container.querySelector('#popup-list');
    const noticeList = container.querySelector('#notice-list');
    const btnSelectSeries = container.querySelector('#btn-select-series');
    const linkInput = container.querySelector('#popup-link');
    const tagSelector = container.querySelector('#notice-tag-selector');
    const customTagInput = container.querySelector('#custom-tag-input');
    const chkAddNotice = container.querySelector('#chk-add-notice');
    const noticeContentArea = container.querySelector('#notice-content-area');
    const noticeContentInput = container.querySelector('#notice-content-input');
    const titleInput = container.querySelector('#popup-title');
    const startDateInput = container.querySelector('#popup-start-date');
    const endDateInput = container.querySelector('#popup-end-date');

    let selectedFile = null;

    // --- 1. Init & View Logic ---
    const today = new Date().toISOString().split('T')[0];
    startDateInput.value = today;

    // Image Preview
    fileInput.onchange = (e) => {
        const file = e.target.files[0];
        if (file) {
            selectedFile = file;
            const reader = new FileReader();
            reader.onload = (ev) => {
                previewImg.src = ev.target.result;
                previewImg.classList.remove('hidden');
            };
            reader.readAsDataURL(file);
        }
    };

    // Series Picker (Standardized)
    btnSelectSeries.onclick = () => {
        new SeriesPickerModal((series) => {
            linkInput.value = `/series/${series.id}`;
        }).render();
    };

    // Toggle Notice
    chkAddNotice.onchange = (e) => {
        if (e.target.checked) {
            noticeContentArea.classList.remove('hidden');
            if (!noticeContentInput.value) {
                const title = titleInput.value || '';
                const start = startDateInput.value || '';
                const end = endDateInput.value || '';
                noticeContentInput.value = `새로운 팝업 이벤트가 시작되었습니다!\n\n${title}\n기간: ${start} ~ ${end}\n\n지금 바로 확인해보세요!`;
            }
        } else {
            noticeContentArea.classList.add('hidden');
        }
    };

    // Toggle Custom Tag
    tagSelector.onchange = (e) => {
        if (e.target.value === 'Custom') {
            customTagInput.classList.remove('hidden');
            customTagInput.focus();
        } else {
            customTagInput.classList.add('hidden');
        }
    };

    // --- 2. Service Integration ---

    // Load Popups
    const loadPopups = async () => {
        popupList.innerHTML = '<div class="col-span-2 text-center py-10"><div class="loader-spin inline-block w-6 h-6 border-b-2 border-blue-600 rounded-full"></div></div>';
        try {
            const list = await AdminPopupService.getPopups();

            if (list.length === 0) {
                popupList.innerHTML = `<div class="col-span-2 text-center text-gray-400 py-10">생산된 팝업이 없습니다.</div>`;
                return;
            }

            popupList.innerHTML = '';
            list.forEach(data => {
                const el = document.createElement('div');
                el.className = "bg-white border rounded-lg p-4 flex gap-4 items-start shadow-sm";
                el.innerHTML = `
                    <div class="w-24 h-24 bg-gray-100 rounded-md overflow-hidden flex-shrink-0 border">
                        <img src="${data.imageUrl}" class="w-full h-full object-cover">
                    </div>
                    <div class="flex-grow min-w-0">
                        <div class="flex justify-between items-start mb-1">
                            <h3 class="font-bold text-gray-900 truncate">${data.title}</h3>
                            <button class="btn-delete text-gray-400 hover:text-red-500 p-1" data-id="${data.id}">
                                <span class="material-symbols-outlined text-lg">delete</span>
                            </button>
                        </div>
                        <p class="text-xs text-gray-500 mb-1">${data.startDate || 'No start'} ~ ${data.endDate || 'No end'}</p>
                        <a href="${data.linkUrl || '#'}" target="_blank" class="text-xs text-blue-500 truncate block hover:underline">${data.linkUrl ? 'Link Attached' : 'No Link'}</a>
                        
                        <div class="mt-2 flex gap-2">
                             <span class="px-2 py-0.5 rounded text-[10px] font-bold ${data.isActive ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'}">
                                ${data.isActive ? 'RUNNING' : 'STOPPED'}
                             </span>
                             ${data.linkedNoticeId ? '<span class="px-2 py-0.5 rounded text-[10px] bg-yellow-100 text-yellow-700">NOTICE LINKED</span>' : ''}
                        </div>
                    </div>
                `;
                popupList.appendChild(el);
            });

            // Bind Delete
            popupList.querySelectorAll('.btn-delete').forEach(btn => {
                btn.onclick = async () => {
                    const confirmed = await ConfirmModal.show({
                        title: "삭제 확인",
                        message: "정말로 삭제하시겠습니까? (연동된 공지사항은 유지됩니다)",
                        confirmText: "삭제",
                        type: "danger"
                    });

                    if (confirmed) {
                        try {
                            await AdminPopupService.deletePopup(btn.dataset.id);
                            loadPopups();
                        } catch (e) {
                            console.error(e);
                            ModalManager.show(AlertModal, "오류", "삭제 실패: " + e.message);
                        }
                    }
                };
            });

        } catch (e) {
            console.error(e);
            popupList.innerHTML = `<div class="col-span-2 text-red-500">목록 로딩 실패</div>`;
        }
    };

    // Load Notices
    const loadNotices = async () => {
        noticeList.innerHTML = '<div class="text-center py-6"><span class="loader-spin inline-block w-5 h-5 border-2 border-gray-300 border-t-gray-500 rounded-full"></span></div>';
        try {
            const list = await AdminPopupService.getNotices();

            if (list.length === 0) {
                noticeList.innerHTML = `<div class="text-center text-gray-400 py-6">등록된 공지사항이 없습니다.</div>`;
                return;
            }

            noticeList.innerHTML = '';
            list.forEach(data => {
                const el = document.createElement('div');
                el.className = "bg-white border rounded-lg p-4 flex gap-4 items-center shadow-sm";
                el.innerHTML = `
                <div class="flex-grow">
                        <div class="flex items-center gap-2 mb-1">
                            <span class="text-[10px] font-bold px-2 py-0.5 rounded ${data.type === 'POPUP_AUTO' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600'}">${data.type || 'NOTICE'}</span>
                            <span class="text-xs text-gray-400">${data.createdAt ? new Date(data.createdAt.toDate()).toLocaleDateString() : ''}</span>
                            ${data.translations ? '<span class="text-[10px] bg-green-100 text-green-700 px-1 rounded">Global</span>' : ''}
                        </div>
                        <h3 class="font-bold text-gray-800 text-sm notice-title">${data.title}</h3>
                        <p class="text-xs text-gray-500 truncate max-w-lg notice-content-text">${data.content}</p>
                        
                        <div class="hidden mt-2 notice-edit-area">
                            <textarea class="w-full text-xs p-2 border rounded notice-edit-input" rows="3">${data.content}</textarea>
                            <div class="flex items-center gap-2 mt-2">
                                <input type="checkbox" id="chk-edit-trans-${data.id}" class="w-3 h-3 text-purple-600 rounded border-gray-300" checked>
                                <label for="chk-edit-trans-${data.id}" class="text-xs text-purple-700 font-bold select-none cursor-pointer">
                                    Auto-Translate (Update 9 Langs)
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col gap-1">
                        <button class="btn-edit-notice text-blue-400 hover:text-blue-600 p-2 hover:bg-blue-50 rounded transition-colors" data-id="${data.id}">
                             <span class="material-symbols-outlined">edit</span>
                        </button>
                        <button class="btn-save-notice hidden text-green-500 hover:text-green-700 p-2 hover:bg-green-50 rounded transition-colors" data-id="${data.id}">
                             <span class="material-symbols-outlined">save</span>
                        </button>
                        <button class="btn-delete-notice text-red-400 hover:text-red-600 p-2 hover:bg-red-50 rounded transition-colors" data-id="${data.id}">
                            <span class="material-symbols-outlined">delete</span>
                        </button>
                    </div>
                `;
                noticeList.appendChild(el);
            });

            // Bind Notice Actions
            // Edit Mode Toggle
            noticeList.querySelectorAll('.btn-edit-notice').forEach(btn => {
                btn.onclick = () => {
                    const container = btn.closest('.shadow-sm');
                    container.querySelector('.notice-content-text').classList.add('hidden');
                    container.querySelector('.notice-edit-area').classList.remove('hidden');
                    btn.classList.add('hidden');
                    container.querySelector('.btn-save-notice').classList.remove('hidden');
                };
            });

            // Save
            noticeList.querySelectorAll('.btn-save-notice').forEach(btn => {
                btn.onclick = async () => {
                    const container = btn.closest('.shadow-sm');
                    const newContent = container.querySelector('.notice-edit-input').value;
                    const chkTrans = container.querySelector(`input[type="checkbox"]`);
                    const titleText = container.querySelector('.notice-title').textContent; // Use existing title

                    try {
                        const updateData = { content: newContent };

                        // [Translation Logic for Edit]
                        if (chkTrans && chkTrans.checked) {
                            btn.innerHTML = '<span class="loader-spin w-4 h-4 border-2 border-green-500 border-t-transparent rounded-full"></span>';

                            const targetLangs = ['en', 'ja', 'zh', 'es', 'fr', 'de', 'vi', 'th', 'ru'];
                            const translations = {};

                            try {
                                const results = await Promise.allSettled(targetLangs.map(async (lang) => {
                                    const [trTitle, trContent] = await Promise.all([
                                        templateTranslationService.translate(titleText, lang),
                                        templateTranslationService.translate(newContent, lang)
                                    ]);
                                    return { lang, title: trTitle, content: trContent };
                                }));

                                results.forEach(res => {
                                    if (res.status === 'fulfilled') {
                                        const { lang, title, content } = res.value;
                                        translations[lang] = { title: title || "", content: content || "" };
                                    }
                                });
                                updateData.translations = translations;
                                console.log("[Notice Edit] Translations updated:", translations);
                            } catch (err) {
                                console.error("Edit Translation Failed:", err);
                                alert("번역 실패! 원문만 수정됩니다.");
                            }
                        }

                        await AdminPopupService.updateNotice(btn.dataset.id, updateData);
                        loadNotices(); // Refresh to confirm
                    } catch (e) {
                        ModalManager.show(AlertModal, "오류", "수정 실패: " + e.message);
                        btn.innerHTML = '<span class="material-symbols-outlined">save</span>';
                    }
                };
            });

            // Delete
            noticeList.querySelectorAll('.btn-delete-notice').forEach(btn => {
                btn.onclick = async () => {
                    const confirmed = await ConfirmModal.show({
                        title: "삭제 확인",
                        message: "정말로 이 공지사항을 삭제하시겠습니까?",
                        confirmText: "삭제",
                        type: "danger"
                    });

                    if (confirmed) {
                        try {
                            await AdminPopupService.deleteNotice(btn.dataset.id);
                            loadNotices();
                        } catch (e) {
                            console.error(e);
                            ModalManager.show(AlertModal, "오류", "삭제 실패: " + e.message);
                        }
                    }
                };
            });

        } catch (e) {
            console.error("Failed to load notices:", e);
            noticeList.innerHTML = `<div class="text-red-500">공지 로딩 실패</div>`;
        }
    };



    // [NEW] Legacy Sync Logic
    const btnSyncAll = container.querySelector('#btn-sync-all-notices');
    btnSyncAll.onclick = async () => {
        if (!confirm("모든 공지사항의 번역 데이터를 동기화하시겠습니까?\n\n- 이미 번역된 데이터는 캐시(DB)에서 가져오므로 API 비용이 들지 않습니다.\n- 누락된 번역을 채워넣습니다.")) return;

        try {
            btnSyncAll.disabled = true;
            btnSyncAll.innerHTML = '<span class="loader-spin w-3 h-3 border-2 border-indigo-700 border-t-transparent rounded-full"></span> 검색 중...';

            const notices = await AdminPopupService.getNotices();
            let updateCount = 0;
            const targetLangs = ['en', 'ja', 'zh', 'es', 'fr', 'de', 'vi', 'th', 'ru'];

            for (let i = 0; i < notices.length; i++) {
                const notice = notices[i];
                btnSyncAll.innerHTML = `<span class="loader-spin w-3 h-3 border-2 border-indigo-700 border-t-transparent rounded-full"></span> Syncing (${i + 1}/${notices.length})...`;

                const titleText = notice.title;
                const contentText = notice.content;
                if (!titleText || !contentText) continue;

                // Check mismatch
                const currentTrans = notice.translations || {};
                const missingLangs = targetLangs.filter(l => !currentTrans[l]);

                if (missingLangs.length > 0) {
                    console.log(`[Sync] Updating Notice ${notice.id} - Missing: ${missingLangs.join(', ')}`);

                    // Fetch from Service (Hits Cache/DB First)
                    await Promise.all(missingLangs.map(async (lang) => {
                        const [trTitle, trContent] = await Promise.all([
                            templateTranslationService.translate(titleText, lang),
                            templateTranslationService.translate(contentText, lang)
                        ]);
                        currentTrans[lang] = { title: trTitle, content: trContent };
                    }));

                    // Update Notice Document
                    await AdminPopupService.updateNotice(notice.id, { translations: currentTrans });
                    updateCount++;

                    // [FIX] Sync to Linked Popup if exists
                    if (notice.linkedPopupId) {
                        console.log(`[Sync] Syncing Linked Popup ${notice.linkedPopupId} for Notice ${notice.id}`);
                        // We need to map Notice content to Popup content (Title, Link)
                        // Popups usually don't have 'content', just Title and Link.
                        // But for generic translation, we can just pass the whole translation object
                        // and let the client pick what it needs (title).

                        const popupTrans = {};
                        Object.keys(currentTrans).forEach(lang => {
                            popupTrans[lang] = {
                                title: currentTrans[lang].title,
                                // Popups might use linkUrl from Notice if we want, but usually link is static.
                                // If we want to translate Link? Maybe.
                                // For now, let's just sync Title.
                                // But wait, the Service creates translations with {title, content}.
                                // Popup needs {title}.
                            };
                        });

                        try {
                            await AdminPopupService.updatePopup(notice.linkedPopupId, { translations: popupTrans });
                        } catch (err) {
                            if (err.code === 'not-found') {
                                console.warn(`[Sync] Linked Popup ${notice.linkedPopupId} not found (Deleted?). Skipping.`);
                            } else {
                                console.error(`[Sync] Failed to update popup ${notice.linkedPopupId}:`, err);
                            }
                        }
                    }
                } else if (notice.translations && notice.linkedPopupId) {
                    // Even if Notice has translations, Popup might not. Force Sync.
                    // This handles the "Previously translated but Popup skipped" case.
                    console.log(`[Sync] Double-check Popup ${notice.linkedPopupId}...`);
                    const popupTrans = {};
                    Object.keys(notice.translations).forEach(lang => {
                        popupTrans[lang] = {
                            title: notice.translations[lang].title
                        };
                    });

                    try {
                        await AdminPopupService.updatePopup(notice.linkedPopupId, { translations: popupTrans });
                    } catch (err) {
                        if (err.code === 'not-found') {
                            console.warn(`[Sync] Linked Popup ${notice.linkedPopupId} not found (Deleted?). Skipping.`);
                        } else {
                            console.error(`[Sync] Failed to update popup ${notice.linkedPopupId}:`, err);
                        }
                    }
                }
            }

            loadNotices();
            ModalManager.show(AlertModal, "동기화 완료", `총 ${updateCount}개의 공지사항 데이터를 복구/동기화했습니다.`);

        } catch (e) {
            console.error(e);
            ModalManager.show(AlertModal, "동기화 실패", e.message);
        } finally {
            btnSyncAll.disabled = false;
            btnSyncAll.innerHTML = '<span class="material-symbols-outlined text-sm">sync_alt</span> Legacy Data Sync (비용 0원)';
        }
    };

    // Produce (Create) Logic
    btnProduce.onclick = async () => {
        if (!selectedFile) {
            ModalManager.show(AlertModal, "필수 항목 누락", "이미지를 선택해주세요! 팝업 팩토리는 이미지가 필수입니다.");
            return;
        }

        const title = titleInput.value;
        const link = linkInput.value;
        const startDate = startDateInput.value;
        const endDate = endDateInput.value;
        const addToNotice = chkAddNotice.checked;

        if (!title) {
            ModalManager.show(AlertModal, "필수 항목 누락", "제목을 입력해주세요.");
            return;
        }

        try {
            btnProduce.disabled = true;

            // Status: Compressing
            btnProduce.innerHTML = `<span class="loader-spin w-5 h-5 border-white border-t-transparent"></span> 📸 이미지 압축 중...`;

            // 1. Compress Image (Client Side)
            const { convertToWebP } = await import('../../utils/image-processor.js');
            const compressedBlob = await convertToWebP(selectedFile, { maxWidth: 1200, quality: 0.8 });

            // Status: Uploading & Saving
            btnProduce.innerHTML = `<span class="loader-spin w-5 h-5 border-white border-t-transparent"></span> 🏭 생산 중...`;

            // 2. Create Popup
            const popupResult = await AdminPopupService.createPopup({
                title,
                linkUrl: link,
                startDate,
                endDate
            }, compressedBlob, selectedFile.name);

            // 3. Optional: Add to Notice
            if (addToNotice) {
                const tagSelection = tagSelector.value;
                const customTag = customTagInput.value.trim();
                const finalTag = (tagSelection === 'Custom' ? customTag : tagSelection) || 'Notice';

                const customContent = noticeContentInput.value;
                const finalContent = customContent || `새로운 팝업 이벤트가 시작되었습니다!\n\n${title}\n기간: ${startDate} ~ ${endDate}\n\n지금 바로 확인해보세요!`;
                const finalTitle = `[${finalTag}] ${title}`;

                // [Translation]
                let translations = {};
                if (container.querySelector('#chk-auto-translate').checked) {
                    btnProduce.innerHTML = `<span class="loader-spin w-5 h-5 border-white border-t-transparent"></span> 🇧🇷 🇯🇵 🇺🇸 번역 중 (9개국어)...`;

                    const targetLangs = ['en', 'ja', 'zh', 'es', 'fr', 'de', 'vi', 'th', 'ru'];
                    try {
                        const results = await Promise.all(targetLangs.map(async (lang) => {
                            const [trTitle, trContent] = await Promise.all([
                                templateTranslationService.translate(finalTitle, lang),
                                templateTranslationService.translate(finalContent, lang)
                            ]);
                            return { lang, title: trTitle, content: trContent };
                        }));

                        results.forEach(res => {
                            translations[res.lang] = { title: res.title, content: res.content };
                        });
                        console.log("[Popup] Translations generate:", translations);
                    } catch (err) {
                        console.error("Translation Failed (Partial or All):", err);
                        // Make non-blocking warning?
                        ModalManager.show(AlertModal, "번역 경고", "일부 언어 번역에 실패했습니다. 원문으로 저장됩니다.");
                    }
                }

                await AdminPopupService.createNotice({
                    title: finalTitle,
                    content: finalContent,
                    imageUrl: popupResult.imageUrl,
                    linkUrl: link,
                    type: 'POPUP_AUTO',
                    linkedPopupId: popupResult.id,
                    translations // Save Translations
                });

                // [FIX] Also update the Popup with translations
                if (Object.keys(translations).length > 0) {
                    await AdminPopupService.updatePopup(popupResult.id, { translations });
                }
            }

            ModalManager.show(AlertModal, "생산 완료", "✅ 팝업 생산 및 배포 완료! (WebP 압축 적용됨)");

            // Reset Form
            titleInput.value = '';
            linkInput.value = '';
            fileInput.value = '';
            previewImg.classList.add('hidden');
            selectedFile = null;

            // Reloads
            loadPopups();
            loadNotices();

        } catch (e) {
            console.error(e);
            ModalManager.show(AlertModal, "오류", "생산 실패: " + e.message);
        } finally {
            btnProduce.disabled = false;
            btnProduce.innerHTML = `<span class="material-symbols-outlined">precision_manufacturing</span> 생산 시작 (저장)`;
        }
    };

    // Initial Load
    loadPopups();
    loadNotices();

    // ==========================================
    // [NEW] Copyright Police Factory Section
    // ==========================================
    const renderCopyrightPoliceSection = async () => {
        const policeSection = document.createElement('div');
        policeSection.className = "mt-12 pt-8 border-t border-gray-200";
        policeSection.innerHTML = `
            <div class="flex items-center justify-between mb-6">
                <h2 class="text-xl font-bold flex items-center gap-2 text-gray-900">
                    <span class="material-symbols-outlined text-red-600">security</span>
                    저작권 경찰 제어반 (Copyright Police)
                </h2>
                <div class="flex items-center gap-2">
                    <span class="text-xs text-gray-500 font-bold uppercase tracking-wider">Status</span>
                    <span id="cp-status-badge" class="px-2 py-1 bg-gray-100 text-gray-500 rounded text-xs font-bold">LOADING</span>
                </div>
            </div>

            <div class="bg-zinc-50 border border-zinc-200 rounded-xl p-6 shadow-sm">
                <!-- Mode Toggle -->
                <div class="flex gap-4 mb-6">
                    <label class="flex items-center gap-2 cursor-pointer">
                        <input type="radio" name="cp_mode" value="default" class="w-4 h-4 text-blue-600 focus:ring-blue-500">
                        <span class="font-bold text-gray-700">기본(Default) 모드</span>
                    </label>
                    <label class="flex items-center gap-2 cursor-pointer">
                        <input type="radio" name="cp_mode" value="custom" class="w-4 h-4 text-red-600 focus:ring-red-500">
                        <span class="font-bold text-gray-700">사용자 정의(Custom) 모드</span>
                    </label>
                </div>

                <!-- Custom Editor Area -->
                <div id="cp-editor" class="space-y-4 opacity-50 pointer-events-none transition-opacity duration-300">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label class="block text-xs font-bold text-gray-500 mb-1">경고창 제목</label>
                            <input type="text" id="cp-title" class="w-full px-3 py-2 border rounded-lg text-sm font-bold" placeholder="예: 동작 그만! 캡처냐?">
                        </div>
                        <div>
                            <label class="block text-xs font-bold text-gray-500 mb-1">테마 (Theme)</label>
                            <select id="cp-theme" class="w-full px-3 py-2 border rounded-lg text-sm bg-white">
                                <option value="standard">Standard (기본)</option>
                                <option value="police">Police (경찰관 - 다빈치 스타일)</option>
                                <option value="romance">Romance (로맨스)</option>
                                <option value="horror">Horror (공포)</option>
                            </select>
                        </div>
                    </div>

                    <div>
                        <label class="block text-xs font-bold text-gray-500 mb-1">법적 고지 / 경고 문구 (HTML 지원)</label>
                        <textarea id="cp-legal-text" class="w-full px-3 py-2 border rounded-lg text-sm h-24 font-mono resize-none focus:ring-2 focus:ring-red-500 outline-none" placeholder="HTML 태그 사용 가능..."></textarea>
                    </div>

                    <div>
                        <label class="block text-xs font-bold text-gray-500 mb-1">확인 버튼 텍스트</label>
                        <input type="text" id="cp-button-text" class="w-full px-3 py-2 border rounded-lg text-sm" placeholder="예: 아닙니다! 눈으로만 보겠습니다!">
                    </div>
                </div>

                <!-- Action Buttons -->
                <div class="flex justify-between items-center mt-6 border-t border-zinc-200 pt-4">
                    <div class="flex items-center gap-2">
                         <input type="checkbox" id="chk-cp-auto-translate" class="w-4 h-4 text-red-600 rounded border-gray-300 focus:ring-red-500" checked>
                         <label for="chk-cp-auto-translate" class="text-xs font-bold text-red-700 select-none cursor-pointer flex items-center gap-1">
                             <span class="material-symbols-outlined text-sm">translate</span>
                             Auto-Translate (9 Languages)
                         </label>
                    </div>

                    <div class="flex gap-3">
                        <button id="btn-cp-preview" class="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg text-sm font-bold flex items-center gap-1 transition-colors">
                            <span class="material-symbols-outlined text-lg">visibility</span>
                            미리보기 (Test)
                        </button>
                        <button id="btn-cp-save" class="px-6 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-bold flex items-center gap-1 shadow-md transition-all active:scale-95">
                            <span class="material-symbols-outlined text-lg">save</span>
                            설정 저장 및 배포
                        </button>
                    </div>
                </div>
            </div>
        `;
        container.appendChild(policeSection);

        // Logic
        const modeRadios = policeSection.querySelectorAll('input[name="cp_mode"]');
        const editorDiv = policeSection.querySelector('#cp-editor');
        const statusBadge = policeSection.querySelector('#cp-status-badge');

        const inputs = {
            title: policeSection.querySelector('#cp-title'),
            theme: policeSection.querySelector('#cp-theme'),
            legalText: policeSection.querySelector('#cp-legal-text'),
            buttonText: policeSection.querySelector('#cp-button-text')
        };
        const btnSave = policeSection.querySelector('#btn-cp-save');
        const btnPreview = policeSection.querySelector('#btn-cp-preview');

        // Load Settings
        try {
            const settings = await AdminPopupService.getCopyrightSettings();

            // Set Values
            if (settings.mode === 'custom') {
                modeRadios[1].checked = true;
                editorDiv.classList.remove('opacity-50', 'pointer-events-none');
                statusBadge.textContent = "CUSTOM MODE";
                statusBadge.className = "px-2 py-1 bg-red-100 text-red-700 rounded text-xs font-bold";

                // [Translation Verification]
                if (settings.translations) {
                    const langs = Object.keys(settings.translations).join(', ').toUpperCase();
                    statusBadge.innerHTML += ` <br><span class="text-[10px] font-normal">Translated: ${langs}</span>`;
                } else {
                    statusBadge.innerHTML += ` <br><span class="text-[10px] text-gray-400">No Translations</span>`;
                }

            } else {
                modeRadios[0].checked = true;
                statusBadge.textContent = "DEFAULT MODE";
                statusBadge.className = "px-2 py-1 bg-gray-100 text-gray-600 rounded text-xs font-bold";
            }

            inputs.title.value = settings.title || '';
            inputs.theme.value = settings.theme || 'standard';
            inputs.legalText.value = settings.legalText || '';
            inputs.buttonText.value = settings.buttonText || '';

        } catch (e) {
            console.error(e);
            ModalManager.show(AlertModal, "오류", "설정 로딩 실패");
        }

        // Toggle Logic
        modeRadios.forEach(r => {
            r.onchange = (e) => {
                if (e.target.value === 'custom') {
                    editorDiv.classList.remove('opacity-50', 'pointer-events-none');
                    statusBadge.textContent = "CUSTOM (Unsaved)";
                    statusBadge.className = "px-2 py-1 bg-yellow-100 text-yellow-700 rounded text-xs font-bold";
                } else {
                    editorDiv.classList.add('opacity-50', 'pointer-events-none');
                    statusBadge.textContent = "DEFAULT (Unsaved)";
                    statusBadge.className = "px-2 py-1 bg-yellow-100 text-yellow-700 rounded text-xs font-bold";
                }
            };
        });

        // Save Logic
        btnSave.onclick = async () => {
            const mode = document.querySelector('input[name="cp_mode"]:checked').value;
            let data = {
                mode,
                title: inputs.title.value,
                theme: inputs.theme.value,
                legalText: inputs.legalText.value,
                buttonText: inputs.buttonText.value
            };

            try {
                btnSave.disabled = true;
                btnSave.innerHTML = `<span class="loader-spin w-4 h-4 border-2 border-white/50 border-t-white rounded-full"></span> 저장 중...`;

                // [Translation Logic]
                const chkAuto = policeSection.querySelector('#chk-cp-auto-translate');
                if (chkAuto && chkAuto.checked && mode === 'custom') {
                    btnSave.innerHTML = `<span class="loader-spin w-4 h-4 border-2 border-white/50 border-t-white rounded-full"></span> 9개국어 번역 중...`;

                    const targetLangs = ['en', 'ja', 'zh', 'es', 'fr', 'de', 'vi', 'th', 'ru'];
                    let translations = {};

                    try {
                        const results = await Promise.allSettled(targetLangs.map(async (lang) => {
                            const [trTitle, trLegal, trBtn] = await Promise.all([
                                templateTranslationService.translate(data.title, lang),
                                templateTranslationService.translate(data.legalText, lang),
                                templateTranslationService.translate(data.buttonText, lang)
                            ]);
                            return { lang, title: trTitle, legalText: trLegal, buttonText: trBtn };
                        }));

                        results.forEach(res => {
                            if (res.status === 'fulfilled') {
                                const { lang, title, legalText, buttonText } = res.value;
                                translations[lang] = {
                                    title: title || "",
                                    legalText: legalText || "",
                                    buttonText: buttonText || ""
                                };
                            }
                        });
                        data.translations = translations;
                        console.log("[Copyright] Translations added:", translations);

                    } catch (err) {
                        console.error("Copyright Translation Failed:", err);
                        ModalManager.show(AlertModal, "번역 실패", "원문만 저장됩니다.");
                    }
                }

                await AdminPopupService.updateCopyrightSettings(data);

                ModalManager.show(AlertModal, "완료", "✅ 저작권 경찰 설정이 업데이트되었습니다.\n모든 뷰어에 즉시 반영됩니다.");

                // Update Badge
                if (mode === 'custom') {
                    statusBadge.textContent = "CUSTOM MODE";
                    statusBadge.className = "px-2 py-1 bg-red-100 text-red-700 rounded text-xs font-bold";
                } else {
                    statusBadge.textContent = "DEFAULT MODE";
                    statusBadge.className = "px-2 py-1 bg-gray-100 text-gray-600 rounded text-xs font-bold";
                }

            } catch (e) {
                console.error(e);
                ModalManager.show(AlertModal, "오류", "저장 실패: " + e.message);
            } finally {
                btnSave.disabled = false;
                btnSave.innerHTML = `<span class="material-symbols-outlined text-lg">save</span> 설정 저장 및 배포`;
            }
        };

        // Preview Logic
        btnPreview.onclick = async () => {
            // Import CopyrightWarning Dynamically
            const { CopyrightWarning } = await import("../../components/feature/viewer/CopyrightWarning.js");

            const mode = document.querySelector('input[name="cp_mode"]:checked').value;
            let config = {};

            if (mode === 'custom') {
                config = {
                    title: inputs.title.value,
                    theme: inputs.theme.value,
                    legalText: inputs.legalText.value,
                    buttonText: inputs.buttonText.value,
                    icon: inputs.theme.value === 'police' ? '👮‍♂️' : (inputs.theme.value === 'horror' ? '👻' : '⚠️')
                };
            } else {
                // Default config will be used by component internal defaults
                config = {};
            }

            // Trigger Warning
            CopyrightWarning(document.body, config);
        };
    };

    renderCopyrightPoliceSection();

    return container;
};
